import { StatusBadge } from '@atrvd/saas-ui'

/**
 * Organization status type
 */
type OrganizationStatus = 'active' | 'suspended'

/**
 * Props for the OrganizationStatusBadge component
 */
interface OrganizationStatusBadgeProps {
  /** The status of the organization */
  status: OrganizationStatus
}

/**
 * Badge component for displaying organization status with icon
 */
export function OrganizationStatusBadge({ status }: OrganizationStatusBadgeProps) {
  const statusType = status === 'active' ? 'success' : 'warning'
  const label = status === 'active' ? 'Active' : 'Suspended'
  return <StatusBadge status={statusType} label={label} showIcon />
}
